import { useTranslation } from 'react-i18next'

import { getContentfulLocaleForLanguage } from '../i18n/locale'

export function getPreferredLocale(language: string | undefined) {
  const normalized = (language ?? 'en').toLowerCase()
  return normalized.startsWith('sv') ? 'sv-SE' : 'en-US'
}

export function useContentfulLocale() {
  const { i18n } = useTranslation()
  const language = i18n.resolvedLanguage ?? i18n.language
  return getContentfulLocaleForLanguage(language)
}
